// import * from ./schemas
// import * from ./displayTypes

// accepts: 
// data object
// schema object
// isEditable boolean
//
// checks display type and renders with the appropriate DisplayType from ./displayTypes 
// standard displayTypes are like text, number, dropdown, checkbox, etc.
// two special types are array and object in which we will iterate
// arrays should be vectors, all items should be the same type
// isCollapsable  

import React, { Component } from 'react'
// import InputTextCP from './displayTypes/InputTextCP'
import DisplayTypes from './displayTypes/DisplayTypes'
import './displaySchema.css'

class DisplayBySchemaCP extends Component {
  constructor (props) {
    super(props)
    if (!'isEditable' in props) props.isEditable = true
  }

  // componentDidMount() {}

  render () {
    switch (this.props.meta.displayType) {
      case DisplayTypes['COLLECTION'].id:
        return this.renderCollection()
      case DisplayTypes['LIST'].id:
        return this.renderList()
  
      default:
        return this.renderItem()
    }
  }

  renderItem () {
    if (!this.props.meta.displayViewable) return []

    let isEditable = this.props.isEditable && this.props.meta.displayEditable
    // make the input item dynamic
    var DisplayElement = DisplayTypes[this.props.meta.displayType].element
    let invalidMessEle = null
    
    if (this.props.meta.invalidMessage && this.props.meta.invalidMessage != '') {
      invalidMessEle = (<div className='dsInvalidMessage'>{this.props.meta.invalidMessage}</div>)
    }
    return (
      <div className='spacerEle'>
        {invalidMessEle}
        {this.props.meta.displayName}: <DisplayElement objPath={this.props.objPath} isEditable={isEditable} value={this.props.value} meta={this.props.meta} onChange={this.props.onChange} />
      </div>
    )
  }

  renderList () {
    var jsx = []
    if (this.props.meta.itemSchema.displayViewable) {
      let isEditable = this.props.isEditable && this.props.meta.itemSchema.displayEditable
      this.props.value.forEach((item, index) => {
        let objPath = `${this.props.objPath}[${index}]`
        let displayName = `${this.props.meta.itemSchema.displayName} ${index+1}`
        let meta = { ...this.props.meta.itemSchema, displayName}
        jsx.push(<DisplayBySchemaCP objPath={objPath} key={objPath} isEditable={isEditable} value={item} meta={meta} onChange={this.props.onChange} />)
      })
    }
    // ToDo: repeat code below
    if (this.props.omitRootContain) {
      return (
        <>
          {jsx}
        </>
      )
    } else {
      return (
        <>
          <div className='dsHeader'>{this.props.meta.displayName}</div>
          <div className='dsIndent'>
            {jsx}
          </div>
          <div className='dsFooter'></div>
        </>
      )
    }
  }

  renderCollection () {
    var jsx = []
    let keysByOrder = Object.entries(this.props.meta.properties).sort((a,b) => a[1].displayOrder - b[1].displayOrder)
    for (const [key, value] of keysByOrder) {
      if (key in this.props.value && key in this.props.meta.properties && this.props.meta.properties[key].displayViewable) {
        let value = this.props.value[key]
        let meta = this.props.meta.properties[key]
        let isEditable = this.props.isEditable && meta.displayEditable
        let objPath = `${this.props.objPath}.${key}`
        jsx.push(<DisplayBySchemaCP objPath={objPath} key={objPath} isEditable={isEditable} value={value} meta={meta} onChange={this.props.onChange} />)
      }
    }
    if (this.props.omitRootContain) {
      return (
        <>
          {jsx}
        </>
      )
    } else {
      return (
        <>
          <div className='dsHeader'>{this.props.meta.displayName}</div>
          <div className='dsIndent'>
            {jsx}
          </div>
          <div className='dsFooter'></div>
        </>
      )
    }
  }

  _onChange (event) {
    this.props.onChange(event)
  }

}

export default DisplayBySchemaCP
